import { useState } from "react";
import { Button, Col, Form, Input, Row, Spin } from "antd";

import AppCard from "../../components/AppCard";

const UpdateSystem = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = (value) => {
    console.log(value);
  };

  return (
    <Spin spinning={loading}>
      <AppCard heading="Edit System">
        <Form onFinish={onFinish} form={form} layout="vertical">
          <Row>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="system" label="System Name" rules={[{ required: true, message: "Please enter system name" }]}>
                <Input placeholder="Enter system name" />
              </Form.Item>
            </Col>
          </Row>
          <Button type="primary" htmlType="submit">
            Update System
          </Button>
        </Form>
      </AppCard>
    </Spin>
  );
};

export default UpdateSystem;
